// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6740) return "static/chunks/6740.fe3291ba755616f3.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"342":"67e724d2","5621":"38754a86","8693":"f3978ade","9013":"f845d0e3"}[chunkId] || chunkId) + "-" + {"342":"5799dabd81d95780","5621":"c4df6bc56a1e7ca6","5737":"7916745993fee0b5","8693":"268a8b1376715444","9013":"4cb248a941bf65ac"}[chunkId] + ".js";
};